<template>
  <div class="home wrapper">
    <div class="content">
      <Header></Header>
      <Loading :loading="loading"></Loading>

      <div :class="{ 'hidden': loading }">
        <Breadcrumb :breadcrumbs="breadcrumbs"></Breadcrumb>
        <Title :title="'Orçamentos'"></Title>

        <div class="container items-container">
          <div class="row">
            <div class="col-12">

              <div class="atos-oficiais" v-for="card in cardList">

                <h2 class="orcamentos-ano">
                  {{ card.year }}
                </h2>
                <!-- /.orcamentos-ano -->

                <Arquivo v-for="item in card.items" :title="item.title" :file="item.url"></Arquivo>
              </div>
              <!-- /.atos-oficiais -->
            </div>
          </div>
          <!-- /.row -->
        </div>
        <!-- /.container -->

      </div>
      <!--== /.hidden ==-->

    </div>
    <!-- /.content -->

    <Footer></Footer>
  </div>
  <!-- /.home wrapper -->
</template>

<script>
  import Header from '../../components/Header.vue';
  import Footer from '../../components/Footer.vue';
  import Breadcrumb from '../../components/Breadcrumb.vue';
  import Arquivo from '../../components/generic/Arquivo.vue';
  import Title from '../../components/generic/Title.vue';
  import Loading from '../../components/generic/Loading.vue';
  import axios from 'axios';
  import env from '../../config/env';

  export default {
    name: 'orcamentos',
    components: {
      Header,
      Footer,
      Breadcrumb,
      Arquivo,
      Title,
      Loading,
    },
    data () {
      return {
        cardList: [],
        loading: true,
        breadcrumbs: [
          {
            name: 'Início',
            link: '/'
          },
          {
            name: 'Orçamentos e Finanças',
            link: '/orcamentosefinancas'
          },
          {
            name: 'Orçamentos'
          }
        ]
      }
    },
    mounted () {
      axios
        .get(env.api.ORCAMENTOS)
        .then(response => {
          this.cardList = response.data;
          this.loading = false;
        });
    }
  };
</script>

<style lang="scss" scoped>
  .orcamentos-ano {
    margin: 20px 0;

    font-family: 'Lato', sans-serif;
    font-weight: 700;
    text-align: center;
    color: #396b84;
  }
</style>
